import { useEffect, useRef } from 'react';

export function ClownOverlay({ showClown }) {
  const audioRef = useRef(null);

  useEffect(() => {
    if (showClown) {
      if (audioRef.current) {
        audioRef.current.currentTime = 0;
        audioRef.current.play().catch(() => {});
      }
    }
  }, [showClown]);

  return (
    <>
      <audio ref={audioRef} src="/assets/clown-sound.mp3" preload="auto" />
      <div style={{
        position: 'absolute',
        bottom: '85px',
        left: 0,
        zIndex: 25,
        transform: showClown ? 'translateX(0)' : 'translateX(-110%)',
        transition: 'transform 0.6s cubic-bezier(0.34, 1.56, 0.64, 1)',
        pointerEvents: 'none',
      }}>
        <img
          src="/assets/clown.png"
          alt=""
          style={{
            height: '70vh',
            maxHeight: '700px',
            objectFit: 'contain',
            filter: 'drop-shadow(8px 4px 20px rgba(0,0,0,0.5))',
          }}
        />
      </div>
    </>
  );
}

export function KingOverlay({ showKing }) {
  const audioRef = useRef(null);

  useEffect(() => {
    if (showKing) {
      if (audioRef.current) {
        audioRef.current.currentTime = 0;
        audioRef.current.play().catch(() => {});
      }
    }
  }, [showKing]);

  return (
    <>
      <audio ref={audioRef} src="/assets/king-sound.mp3" preload="auto" />
      <div style={{
        position: 'absolute',
        bottom: '85px',
        left: 0,
        zIndex: 25,
        transform: showKing ? 'translateX(0)' : 'translateX(-110%)',
        transition: 'transform 0.6s cubic-bezier(0.34, 1.56, 0.64, 1)',
        pointerEvents: 'none',
      }}>
        <img
          src="/assets/king.png"
          alt=""
          style={{
            height: '70vh',
            maxHeight: '700px',
            objectFit: 'contain',
            filter: 'drop-shadow(8px 4px 20px rgba(0,0,0,0.5))',
          }}
        />
      </div>
    </>
  );
}
